import { useEffect, useState } from "react";

export function useNow(every: number): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    // Aligned to the next `every` boundary so the screen never lags the clock.
    const tick = setTimeout(
      () => setNow(new Date()),
      every - (now.getTime() % every),
    );
    return () => clearTimeout(tick);
  }, [now, every]);

  useEffect(() => {
    // Hidden tabs throttle timers and sleep delays them, so a returning tab reads the clock now.
    const read = () => {
      if (document.visibilityState === "visible") setNow(new Date());
    };
    document.addEventListener("visibilitychange", read);
    return () => document.removeEventListener("visibilitychange", read);
  }, []);

  return now;
}
